import { Trans } from '@lingui/macro'
import { authRoles } from 'app/auth/authRoles'
import { EgretLoadable } from 'egret'

export const FUNDING_PATHS = {
  APPLICATIONS_LIST: '/grants/applications',
  FUNDING: '/grants/how-to-apply',
  APPLY: '/grants/apply'
}

const Apply = EgretLoadable({
  loader: () => import('./ApplyForFunding')
})

const ApplicationsList = EgretLoadable({
  loader: () => import('../grants/applications/ApplicationsList')
})

const HowToApply = EgretLoadable({
  loader: () => import('./HowToApply')
})

const fundingRoutes = [
  {
    path: FUNDING_PATHS.APPLY,
    component: Apply,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_APPLY_FOR_FUNDING</Trans>,
  },
  {
    path: FUNDING_PATHS.APPLICATIONS_LIST,
    component: ApplicationsList,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_APPLICATIONS</Trans>,
    showCollapseBtn: true,
  },
  {
    path: FUNDING_PATHS.FUNDING,
    component: HowToApply,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_HOW_TO_APPLY</Trans>,
  },
]

export default fundingRoutes
